import { AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2 } from 'elements/hardwareFilter/acVoltageRating/constants'
import {
  CURRENT_RATING_FILTER_GTE_KEY,
  CURRENT_RATING_FILTER_LTE_KEY,
} from 'elements/hardwareFilter/currentRating/constants'
import { PHASE_FILTER_KEY_V2 } from 'elements/hardwareFilter/phaseType/PhaseTypeFilterNodeFactoryV2'
import { VOLTAGE_AND_CURRENT_FILTER_KEY_V2 } from 'elements/hardwareFilter/voltageAndCurrent/VoltageAndCurrentFilterNodeFactoryV2'

/** Stripped when current_type is DC. */
export const DC_ONLY_HARDWARE_LIST_KEYS = [VOLTAGE_AND_CURRENT_FILTER_KEY_V2] as const

/** Stripped when current_type is unset — require explicit AC (unlike phase_type, which also applies to inverters). */
export const AC_CURRENT_TYPE_ONLY_HARDWARE_LIST_KEYS = [
  CURRENT_RATING_FILTER_GTE_KEY,
  CURRENT_RATING_FILTER_LTE_KEY,
  AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2,
] as const

/** All AC-side filters — stripped together when current_type is DC. */
export const AC_ONLY_HARDWARE_LIST_KEYS = [PHASE_FILTER_KEY_V2, ...AC_CURRENT_TYPE_ONLY_HARDWARE_LIST_KEYS] as const

const omitHardwareListKeys = (merged: Record<string, unknown>, keys: readonly string[]): Record<string, unknown> => {
  const next = { ...merged }
  for (const key of keys) {
    delete next[key]
  }
  return next
}

export const omitConflictingCurrentTypeFilters = (
  merged: Record<string, unknown>,
  selectedCurrentType: string
): Record<string, unknown> => {
  if (selectedCurrentType === 'ac') {
    return omitHardwareListKeys(merged, DC_ONLY_HARDWARE_LIST_KEYS)
  }
  if (selectedCurrentType === 'dc') {
    return omitHardwareListKeys(merged, AC_ONLY_HARDWARE_LIST_KEYS)
  }
  // Unset — strip DC filters and AC filters that need current_type=ac; keep phase_type for inverters.
  return omitHardwareListKeys(merged, [...DC_ONLY_HARDWARE_LIST_KEYS, ...AC_CURRENT_TYPE_ONLY_HARDWARE_LIST_KEYS])
}
